import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './PlanReviewReminderText.module.scss'

interface IPlanReviewReminderTextProps {
  text: string
  links?: string
  onLinkClick: (link: string) => () => void
}

const renderTextWithButtons = (
  text: string,
  links: Record<string, string>,
  onLinkClick: (link: string) => () => void
) => {
  const keys = Object.keys(links).map((key) => `\\{${key}\\}`) // Экранируем `{}` для RegExp
  const regex = new RegExp(`(${keys.join('|')})`, 'g')

  return text.split(regex).map((part, index) => {
    const linkKey = part.replace(/[{}]/g, '') // Убираем `{}` для получения ключа
    if (links[linkKey]) {
      return (
        <div key={index} className={styles.link} onClick={onLinkClick(links[linkKey])}>
          <Translation
            text={`jbp-commitment-${linkKey.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`}
          />
        </div>
      )
    }
    return part
  })
}

export const PlanReviewReminderText = ({
  links,
  text,
  onLinkClick,
}: IPlanReviewReminderTextProps) => {
  const parsedLinks = useMemo(() => {
    if (!links) {
      return {}
    }
    return parseJson<Record<string, string>>(links) ?? {}
  }, [links])

  return <div className={styles.root}>{renderTextWithButtons(text, parsedLinks, onLinkClick)}</div>
}
